import { Claim } from "../../../api/ClientFileApi";
import { hasEntryOnOrAfter, newestBalanceEntryOf } from "../../utils/claimBalance";
import { CarryForwardRow } from "./CarryForwardBalancesDialog.types";

/**
 * The selected claims as the overlay lists them, in the order the list shows them. A claim whose
 * balance already stands at <paramref name="today" /> or beyond has nothing left to carry — a second
 * entry sharing a date makes the balance of that day ambiguous, and an entry filed behind a newer one
 * leaves the displayed balance where it is — and one without a history has no amount to repeat. Both
 * are listed as skipped rather than hidden, so the overlay accounts for every row the user ticked.
 * The server decides the same thing again for the request it receives; this is what the user is shown
 * before confirming.
 */
export function carryForwardRowsOf(
  claims: Claim[],
  selectedClaimIds: ReadonlySet<string>,
  today: Date
): CarryForwardRow[] {
  return claims
    .filter((claim) => selectedClaimIds.has(claim.id))
    .map((claim) => {
      const newestEntry = newestBalanceEntryOf(claim);

      return {
        claim,
        newestEntry,
        skipReason: newestEntry === null ? "noHistory" : hasEntryOnOrAfter(claim, today) ? "alreadyUpToDate" : null,
      };
    });
}
